import T from "@Tilesets/sewer/tiles.jsx";

export default [
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.NLW_CORNER,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.NRW_CORNER,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.NLW_CORNER,
    T.NLW_COLUMN,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.NRW_COLUMN,
    T.NRW_CORNER,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.L_WALL,
    T.NW_NPIT,
    T.NW_NPIT,
    T.N_STAIRWALL,
    T.NW_NPIT,
    T.NW_NPIT,
    T.R_WALL,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
    T.EMPTY,
  ],
  ...[
    T.EMPTY,
    T.NLW_CORNER,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.NLW_WATER_COLUMN,
    T.WATER,
    T.WATER,
    T.N_STAIR,
    T.WATER,
    T.WATER,
    T.NRW_WATER_COLUMN,
    T.N_WALL,
    T.N_WALL,
    T.N_WALL,
    T.NRW_CORNER,
    T.EMPTY,
  ],
  ...[
    T.NLW_CORNER,
    T.NLW_COLUMN,
    T.FLOOR,
    T.FLOOR,
    T.LW_LPIT,
    T.WATER,
    T.WATER,
    T.WATER,
    T.V_WALKWAY,
    T.WATER,
    T.WATER,
    T.WATER,
    T.RW_RPIT,
    T.FLOOR,
    T.FLOOR,
    T.NRW_COLUMN,
    T.NRW_CORNER,
  ],
  ...[
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.LW_LPIT,
    T.WATER,
    T.WATER,
    T.WATER,
    T.V_WALKWAY,
    T.WATER,
    T.WATER,
    T.WATER,
    T.RW_RPIT,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
  ],
  ...[
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.L_STAIRWALL,
    T.L_STAIR,
    T.H_WALKWAY,
    T.H_WALKWAY,
    T.C_WALKWAY,
    T.H_WALKWAY,
    T.H_WALKWAY,
    T.R_STAIR,
    T.R_STAIRWALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
  ],
  ...[
    T.L_WALL,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.LW_LPIT,
    T.WATER,
    T.WATER,
    T.WATER,
    T.V_WALKWAY,
    T.WATER,
    T.WATER,
    T.WATER,
    T.RW_RPIT,
    T.FLOOR,
    T.FLOOR,
    T.FLOOR,
    T.R_WALL,
  ],
    ...[
      T.SLW_CORNER,
      T.SLW_COLUMN,
      T.FLOOR,
      T.FLOOR,
      T.LW_LPIT,
      T.WATER,
      T.WATER,
      T.WATER,
      T.V_WALKWAY,
      T.WATER,
      T.WATER,
      T.WATER,
      T.RW_RPIT,
      T.FLOOR,
      T.FLOOR,
      T.SRW_COLUMN,
      T.SRW_CORNER,
    ],
    ...[
      T.EMPTY,
      T.SLW_CORNER,
      T.S_WALL,
      T.S_WALL,
      T.S_WALL,
      T.SLW_WATER_COLUMN,
      T.WATER,
      T.WATER,
      T.S_STAIR,
      T.WATER,
      T.WATER,
      T.SRW_WATER_COLUMN,
      T.S_WALL,
      T.S_WALL,
      T.S_WALL,
      T.SRW_CORNER,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.L_WALL,
      T.SW_SPIT,
      T.SW_SPIT,
      T.S_STAIRWALL,
      T.SW_SPIT,
      T.SW_SPIT,
      T.R_WALL,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.L_WALL,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.R_WALL,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.L_WALL,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.R_WALL,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.SLW_CORNER,
      T.SLW_COLUMN,
      T.FLOOR,
      T.FLOOR,
      T.FLOOR,
      T.SRW_COLUMN,
      T.SRW_CORNER,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.SLW_CORNER,
      T.S_WALL,
      T.S_WALL,
      T.S_WALL,
      T.SRW_CORNER,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
    ...[
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
      T.EMPTY,
    ],
  ]